import { useState } from "react";
import api from "../../services/api";

const useContatoFornecedor = () => {

    const [error, setError] = useState(null);

    async function deleteContatoFornecedor(id: string) {
        try {
            const response = await api.delete(`supplier_contacts/${id}`);
            alert("Sucesso: contato do fornecedor excluído!");

            return true;
        } catch (e) {
            setError(e);
            alert("Error: tente novamente!");
            // console.log(error);
        }
    }

    return {deleteContatoFornecedor, error};
}

export default useContatoFornecedor;